import { Fragment } from 'react'

export const HiglightedText = ({
  text,
  textToHighlight,
  highlightColor,
}: {
  text: string
  textToHighlight: string
  highlightColor: string
}) => {
  return (
    <>
      {textToHighlight
        ? text.split(textToHighlight).map((part, index, array) => (
            <Fragment key={index}>
              <span>{part}</span>
              {index < array.length - 1 && (
                <span className={highlightColor}>{textToHighlight}</span>
              )}
            </Fragment>
          ))
        : text}
    </>
  )
}
